import { Context, CustomQuery } from '@vue-storefront/core';
import { WishDelete, ApiResult } from '../../types';

export default async function wishDelete({ client, config }: Context, params: CustomQuery): Promise<ApiResult> {
  const param = { 
    good_id: params.goodId, 
  };
  const url = new URL('/mall/fav/delete', config.api.url);
  const { data:res } = await client.post(url.href, param);
    const WishDelete: WishDelete = {
      data : res.data
    };
    res.data = WishDelete;
    return res;
}
